module.exports = __webpack_public_path__ + "assets/img/w_d_i_5.4aa8a042.jpg";